import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { FileText, CalendarDays, Flame, Users, ChevronRight, Star } from 'lucide-react';
import { galeriaPublicaService } from '../../api/services';
import type { Imagem } from '../../types';
import './home.css';

export default function HomePage() {
  const [capaUrl, setCapaUrl] = useState<string | null>(null);
  const [logoUrl, setLogoUrl] = useState<string | null>(null);

  useEffect(() => {
    galeriaPublicaService.listar('capa').then(r => {
      if (r.imagens.length > 0) setCapaUrl(r.imagens[0].urlPublica);
    }).catch(() => {});
    galeriaPublicaService.listar('logo').then(r => {
      if (r.imagens.length > 0) setLogoUrl(r.imagens[0].urlPublica);
    }).catch(() => {});
  }, []);

  return (
    <div className="home">
      {/* HERO */}
      <section className="hero" style={capaUrl ? { backgroundImage: `url(${capaUrl})` } : undefined}>
        <div className="hero-overlay" />
        <div className="hero-conteudo container">
          {logoUrl ? (
            <img src={logoUrl} alt="LICMAB" className="hero-logo-img" />
          ) : (
            <div className="hero-emblema">
              <div className="emblema-diamante">
                <Star size={32} fill="currentColor" />
              </div>
            </div>
          )}
          <div className="hero-badge">Liga Cultural de Marabá</div>
          <h1 className="hero-titulo">
            LICMAB
          </h1>
          <p className="hero-sub">
            Promovendo cultura, tradição e inclusão social em Marabá, Pará
          </p>
          <p className="hero-slogan">Juntos Somos Mais Fortes ★</p>
          <div className="hero-acoes">
            <Link to="/sobre" className="btn-hero-primario">
              Conheça a LICMAB <ChevronRight size={18} />
            </Link>
            <Link to="/festejo" className="btn-hero-secundario">
              Festejo Junino
            </Link>
          </div>
        </div>
        <div className="hero-scroll">
          <span>↓</span>
        </div>
      </section>

      {/* CARDS DE ACESSO RÁPIDO */}
      <section className="acesso-rapido">
        <div className="container">
          <div className="acesso-grid">
            {[
              {
                to: '/transparencia',
                icone: <FileText size={28} />,
                titulo: 'Transparência',
                desc: 'Atas, balancetes, certidões e documentos oficiais da LICMAB',
                cor: 'azul',
              },
              {
                to: '/eventos',
                icone: <CalendarDays size={28} />,
                titulo: 'Eventos',
                desc: 'Acompanhe as atividades culturais e sociais promovidas pela liga',
                cor: 'dourado',
              },
              {
                to: '/festejo',
                icone: <Flame size={28} />,
                titulo: 'Festejo Junino',
                desc: 'O maior festejo junino de Marabá, com quadrilhas e muito forró',
                cor: 'laranja',
              },
              {
                to: '/sobre',
                icone: <Users size={28} />,
                titulo: 'Sobre Nós',
                desc: 'Fundada em 2015, reunindo grupos culturais de toda Marabá',
                cor: 'verde',
              },
            ].map(card => (
              <Link key={card.to} to={card.to} className={`acesso-card acesso-${card.cor}`}>
                <div className="acesso-icone">{card.icone}</div>
                <h3>{card.titulo}</h3>
                <p>{card.desc}</p>
                <span className="acesso-seta">→</span>
              </Link>
            ))}
          </div>
        </div>
      </section>

      {/* SOBRE */}
      <section className="home-sobre">
        <div className="container">
          <div className="sobre-conteudo">
            <div className="sobre-texto">
              <div className="secao-tag">Quem Somos</div>
              <h2 className="secao-titulo">A Liga Cultural<br />de Marabá</h2>
              <p>
                A LICMAB foi fundada em 15 de outubro de 2015 por dançarinos e artistas de Marabá, 
                com o objetivo de organizar os grupos culturais da cidade e representar suas demandas 
                junto ao poder público.
              </p>
              <p>
                Trabalhamos pela promoção integral da pessoa humana, pela cultura junina, 
                pelo folclore brasileiro e pelas artes cênicas tradicionais do nosso país.
              </p>
              <Link to="/sobre" className="link-mais">
                Saiba mais sobre a LICMAB <ChevronRight size={16} />
              </Link>
            </div>
            <div className="sobre-numeros">
              {[
                { num: '2015', label: 'Ano de fundação' },
                { num: '24+', label: 'Associados fundadores' },
                { num: 'Marabá', label: 'Pará, Brasil' },
                { num: '★', label: 'Juntos somos mais fortes' },
              ].map((item, i) => (
                <div key={i} className="numero-card">
                  <span className="numero-valor">{item.num}</span>
                  <span className="numero-label">{item.label}</span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* CTA FESTEJO */}
      <section className="cta-festejo">
        <div className="container">
          <div className="cta-conteudo">
            <div className="cta-icones">🎪 🌟 🎶</div>
            <h2>Festejo Junino de Marabá</h2>
            <p>Venha pro nosso festejo! Quadrilhas, bois bumbas e marcadores de Marabá.</p>
            <Link to="/festejo" className="btn-cta">
              Ver programação <Flame size={18} />
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
}
